"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBillingSnapshotComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
const billing_service_1 = require("../../billing/services/billing.service");
const account_service_1 = require("../services/account.service");
const generic_content_service_1 = require("../services/generic.content.service");
const helper_service_1 = require("../services/helper.service");
class CSBillingSnapshotComponent {
    constructor(accountService, billingService, genericContentService, modalService, navigateService) {
        this.accountService = accountService;
        this.billingService = billingService;
        this.genericContentService = genericContentService;
        this.modalService = modalService;
        this.navigateService = navigateService;
        this.isAllDevices = true;
        this.loader = false;
        this.moreTransactions = false;
        this.viewText = 'View More';
        this.tooltipContentLoader = false;
        this.cpinRequired = false;
        this.isMobile = false;
        this.htmlString = '<button class="btn btn-primary btn-rounded px-3 py-2" role="button" type="button">VIEW INVOICE</button>';
        this.cpniMessage = '<button class="btn btn-primary btn-rounded px-3 py-2" role="button" type="button">VERIFY CPNI</button>';
        this.rowCount = 6;
    }
    ngOnInit() {
        this.loader = true;
        this.accountService.getAccountDetails()
            .subscribe((accountInfo) => {
            this.loader = false;
            this.isBusiness = accountInfo.businessAccount;
            // get the transaction details only for PP users.
            if (!this.isBusiness) {
                this.getSubDetails();
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
        this.showToolTipContent();
    }
    selectDevice(device, index) {
        this.isAllDevices = false;
        this.device = device;
        this.index = index;
        this.selectedSubDetails = _.sortBy(device === null || device === void 0 ? void 0 : device.transactionDetails, 'transactionDate').reverse();
        this.moreTransactions = this.selectedSubDetails.length > 6 ? true : false;
        this.viewText = this.moreTransactions ? 'View More' : 'View Less';
    }
    selectAllDevice() {
        this.isAllDevices = true;
        this.resetValue();
    }
    /**
     * Get the Sub details
     */
    getSubDetails() {
        this.loader = true;
        this.accountService.getSubTransactionDetails()
            .subscribe((transactionDetails) => {
            this.loader = false;
            if (transactionDetails) {
                this.subsDetails = transactionDetails;
            }
        }, (err) => {
            this.error = err === null || err === void 0 ? void 0 : err.errorMessage;
            this.loader = false;
        });
    }
    showData(evt, date, action) {
        this.loader = true;
        this.billingService.getBill(date)
            .subscribe((bill) => {
            if (!bill) {
                this.showErrorContent();
            }
            else {
                this.loader = true;
                this.cpinRequired = false;
                setTimeout(() => {
                    this.loader = false;
                }, 2000);
            }
        }, (err) => {
            this.loader = false;
            this.error = err === null || err === void 0 ? void 0 : err.errorMessage;
        });
    }
    showErrorContent() {
        this.genericContentService.getGenericContent('generic-errormsg-viewBillMissingB2C').subscribe((data) => {
            this.notFoundContent = data.contentText;
            this.open(this.fileNotFound);
        }, (err) => {
            this.error = err === null || err === void 0 ? void 0 : err.errorMessage;
        });
    }
    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    clickLink(type, date) {
        this.navigateService.onNavigate('/my_account/personal/#/wireless/billing/view/' + date);
    }
    viewMoreTransaction() {
        this.viewText = '';
        if (this.moreTransactions) {
            this.viewText = 'View Less';
            this.rowCount = this.selectedSubDetails.length;
            this.moreTransactions = false;
        }
        else {
            this.viewText = 'View More';
            this.rowCount = 6;
            this.moreTransactions = true;
        }
    }
    resetValue() {
        // reset values
        this.moreTransactions = false;
        this.viewText = 'View More';
        this.rowCount = 6;
    }
    showToolTipContent() {
        this.genericContentService.getGenericContent('genericContentCpniNotVerified').subscribe((data) => {
            this.message = data.contentText;
        }, (err) => {
            this.error = err;
        });
    }
    openTT() {
        this.tooltip.open();
    }
}
exports.CSBillingSnapshotComponent = CSBillingSnapshotComponent;
//# sourceMappingURL=billing-snapshot.component.js.map